export const firebaseConfig = {
  apiKey: 'AIzaSyAdUyKF0xBoeXrS6OHtxbpemx7JDPNp2Zk',
  authDomain: 'gitwit-firebase-project-1.firebaseapp.com',
  projectId: 'gitwit-firebase-project-1',
  storageBucket: 'gitwit-firebase-project-1.appspot.com',
  messagingSenderId: '681084921463',
  appId: '1:681084921463:web:ca6cba3c6d379ddc440872',
};
